// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import uuid from "react-native-uuid";
import { Toastr, Button, Label } from "@revvsales/components";

// Comonents Imports

// Actions Imports
import { updateDocDetails } from "../../actions/DocumentActions";

// Internal Imports
import { EVENTS, DOCUMENTS } from "../../constants";
import { AmplitudeUtils } from "../../utils";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;

const { DOCUMENT_TOASTR_MESSAGE } = DOCUMENTS;
const ENTER_KEY = 13;

class DocNameEditAndContinuePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentName: props.docName,
      showButtunLoader: false,
      errMsg: "",
    };
  }

  componentDidMount() {
    this.documentNameInput.focus();
  }

  _onInputChange = event => {
    this.setState({
      documentName: event.target.value,
      errMsg: "",
    });
  };

  _toggleLoader = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _onSubmit = () => {
    const { documentName } = this.state;
    if (documentName !== this.props.docName) {
      this._updateDocDetails(documentName);
    } else if (this.props.buttonValue === "eSign") {
      const { stripePaymentDetails, buttonData } = this.props;
      if (
        buttonData.length &&
        ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
          !stripePaymentDetails)
      ) {
        // if there is a disabled button in the doc
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          stripeButtonRemovePopup: true,
          buttonValue: this.props.buttonValue,
        });
      } else if (
        this.props.fetchSignersList &&
        this.props.fetchSignersList.length > 0
      ) {
        const signersList = this.props.fetchSignersList;
        let status = true;
        if (Array.isArray(signersList) && signersList.length > 0) {
          status = signersList.every(
            v =>
              v.signer_email !== "" &&
              v.first_name !== "" &&
              v.last_name !== "",
          );
        } else {
          status = false;
        }
        if (status && this.props.checkFormFields()) {
          this.props.updateMultipleState({
            approvalEventUuid: uuid.v4(),
          });
          this.setState({ approvalEventUuid: uuid.v4() }, () =>
            this.props
              .analyzeDoc({
                event: "esign_type",
                event_id: this.state.approvalEventUuid,
                entity: "DEAL",
                entity_id: this.props.docID,
              })
              .then(response => {
                const { Analysis } = response;
                // Check if there is no approval required then, show the "Signer list"
                if (Analysis && Analysis.length === 0) {
                  // if (this.props.checkFormFields()) {
                  this.props.updateMultipleState({
                    showDocNameEditAndContinueModal: false,
                    showAnalysisModal: false,
                    showSignerListPopup: true,
                  });
                  // } else {
                  //   this.props.updateMultipleState({
                  //     showDocNameEditAndContinueModal: false,
                  //     showAnalysisModal: false,
                  //     showSendConfirmationPopup: true,
                  //   });
                  // }
                } else {
                  this.props.updateMultipleState({
                    showDocNameEditAndContinueModal: false,
                    showAnalysisModal: true,
                  });
                }
              }),
          );
        } else if (!this.props.checkFormFields()) {
          this.props.updateMultipleState({
            showDocNameEditAndContinueModal: false,
            showAnalysisModal: false,
            showSendConfirmationPopup: true,
          });
        } else {
          this.props.updateMultipleState({
            showDocNameEditAndContinueModal: false,
            showEmptySignerPopup: true,
          });
        }
      } else if (!this.props.checkFormFields()) {
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          showAnalysisModal: false,
          showSendConfirmationPopup: true,
        });
      } else {
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          showEmptySignerPopup: true,
        });
      }
    } else if (this.props.buttonValue === "forAcceptance") {
      const { stripePaymentDetails, buttonData } = this.props;
      if (
        buttonData.length &&
        ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
          !stripePaymentDetails)
      ) {
        // if there is a disabled button in the doc
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          stripeButtonRemovePopup: true,
          buttonValue: this.props.buttonValue,
        });
      } else if (this.props.checkFormFields()) {
        this.setState({ approvalEventUuid: uuid.v4() }, () =>
          this.props
            .analyzeDoc({
              event_id: this.state.approvalEventUuid,
              entity: "DEAL",
              entity_id: this.props.docID,
            })
            .then(response => {
              const { Analysis } = response;
              // Check if there is no approval required then, show the "Signer list"
              if (Analysis && Analysis.length === 0) {
                // if form field is empty : show sendConfirmationPopup

                this.props.updateMultipleState({
                  showDocNameEditAndContinueModal: false,
                  showAnalysisModal: false,
                  addAcceptorList: true,
                });
              } else {
                this.props.updateMultipleState({
                  showDocNameEditAndContinueModal: false,
                  showAnalysisModal: true,
                });
              }
            }),
        );
      } else {
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          showAnalysisModal: false,
          showSendConfirmationPopup: true,
        });
      }
    } else if (this.props.buttonValue === "forReviewer") {
      // if form fields are not filled - open sendConfirmationPopup
      if (this.props.checkFormFields()) {
        const { stripePaymentDetails, buttonData } = this.props;
        if (
          buttonData.length &&
          ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
            !stripePaymentDetails)
        ) {
          // if there is a disabled button in the doc
          this.props.updateMultipleState({
            showDocNameEditAndContinueModal: false,
            stripeButtonRemovePopup: true,
          });
        } else {
          // if there is no disabled button in the doc
          this.props.updateMultipleState({
            showDocNameEditAndContinueModal: false,
            showAddRecipientsPopup: true,
          });
        }
      } else {
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          showSendConfirmationPopup: true,
        });
      }
    } else if (this.props.buttonValue === "forApproval") {
      const { stripePaymentDetails, buttonData } = this.props;
      if (
        buttonData.length &&
        ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
          !stripePaymentDetails)
      ) {
        // if there is a disabled button in the doc
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          stripeButtonRemovePopup: true,
          buttonValue: this.props.buttonValue,
        });
      } else if (this.props.checkFormFields()) {
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          showAnalysisModal: true,
        });
      } else {
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          showSendConfirmationPopup: true,
        });
      }
    } else if (this.props.buttonValue === "stripePayment") {
      const { stripePaymentDetails, buttonData } = this.props;
      if (
        buttonData.length &&
        ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
          !stripePaymentDetails)
      ) {
        // if there is a disabled button in the doc
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          stripeButtonRemovePopup: true,
          buttonValue: this.props.buttonValue,
        });
      } else if (buttonData.length === 0) {
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          showEmptyStripePaymentPopup: true,
        });
      } else {
        this.props.updateMultipleState({
          showDocNameEditAndContinueModal: false,
          showAddRecipientsPopup: true,
        });
      }
    }
  };

  _updateDocDetails = value => {
    const payload = {
      data: [
        {
          op: "replace",
          field: "title",
          value: {
            title: value,
          },
        },
      ],
      docId: this.props.docID,
    };
    this._toggleLoader("showButtunLoader", true);
    this.props
      .updateDocDetails(payload)
      .then(res => {
        document.title = `Document | ${res.title}`;
        this._toggleLoader("showButtunLoader", false);
        if (this.props.buttonValue === "forReviewer") {
          if (this.props.checkFormFields()) {
            const { stripePaymentDetails, buttonData } = this.props;
            if (
              buttonData.length &&
              ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
                !stripePaymentDetails)
            ) {
              // if there is a disabled button in the doc
              this.props.updateMultipleState({
                showDocNameEditAndContinueModal: false,
                stripeButtonRemovePopup: true,
              });
            } else {
              this.props.updateMultipleState({
                showDocNameEditAndContinueModal: false,
                showAddRecipientsPopup: true,
              });
            }
          } else {
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              showSendConfirmationPopup: true,
            });
          }
        } else if (this.props.buttonValue === "forAcceptance") {
          const { stripePaymentDetails, buttonData } = this.props;
          if (
            buttonData.length &&
            ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
              !stripePaymentDetails)
          ) {
            // if there is a disabled button in the doc
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              stripeButtonRemovePopup: true,
              buttonValue: this.props.buttonValue,
            });
          } else if (this.props.checkFormFields()) {
            this.setState({ approvalEventUuid: uuid.v4() }, () =>
              this.props
                .analyzeDoc({
                  event_id: this.state.approvalEventUuid,
                  entity: "DEAL",
                  entity_id: this.props.docID,
                })
                .then(response => {
                  const { Analysis } = response;
                  // Check if there is no approval required then, show the "Signer list"
                  if (Analysis && Analysis.length === 0) {
                    this.props.updateMultipleState({
                      showDocNameEditAndContinueModal: false,
                      showAnalysisModal: false,
                      addAcceptorList: true,
                    });
                  } else {
                    this.props.updateMultipleState({
                      showDocNameEditAndContinueModal: false,
                      showAnalysisModal: true,
                    });
                  }
                }),
            );
          } else {
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              showAnalysisModal: false,
              showSendConfirmationPopup: true,
            });
          }
        } else if (this.props.buttonValue === "forApproval") {
          const { stripePaymentDetails, buttonData } = this.props;
          if (
            buttonData.length &&
            ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
              !stripePaymentDetails)
          ) {
            // if there is a disabled button in the doc
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              stripeButtonRemovePopup: true,
              buttonValue: this.props.buttonValue,
            });
          } else if (this.props.checkFormFields()) {
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              showAnalysisModal: true,
            });
          } else {
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              showSendConfirmationPopup: true,
            });
          }
        } else if (this.props.buttonValue === "eSign") {
          const { stripePaymentDetails, buttonData } = this.props;
          if (
            buttonData.length &&
            ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
              !stripePaymentDetails)
          ) {
            // if there is a disabled button in the doc
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              stripeButtonRemovePopup: true,
              buttonValue: this.props.buttonValue,
            });
          } else if (
            this.props.components &&
            Object.keys(this.props.components).length > 0
          ) {
            const signersList = this.props.fetchSignersList;
            let status = true;
            if (Array.isArray(signersList) && signersList.length > 0) {
              status = signersList.every(
                v =>
                  v.signer_email !== "" &&
                  v.first_name !== "" &&
                  v.last_name !== "",
              );
            } else {
              status = false;
            }
            if (this.props.checkFormFields()) {
              if (status) {
                this.props.updateMultipleState({
                  approvalEventUuid: uuid.v4(),
                });
                this.setState({ approvalEventUuid: uuid.v4() }, () =>
                  this.props
                    .analyzeDoc({
                      event: "esign_type",
                      event_id: this.state.approvalEventUuid,
                      entity: "DEAL",
                      entity_id: this.props.docID,
                    })
                    .then(response => {
                      const { Analysis } = response;
                      // Check if there is no approval required then, show the "Signer list"
                      if (Analysis && Analysis.length === 0) {
                        if (this.props.checkFormFields()) {
                          this.props.updateMultipleState({
                            showDocNameEditAndContinueModal: false,
                            showAnalysisModal: false,
                            showSignerListPopup: true,
                          });
                        } else {
                          this.props.updateMultipleState({
                            showDocNameEditAndContinueModal: false,
                            showAnalysisModal: false,
                            showSendConfirmationPopup: true,
                          });
                        }
                      } else {
                        this.props.updateMultipleState({
                          showDocNameEditAndContinueModal: false,
                          showAnalysisModal: true,
                        });
                      }
                    }),
                );
              } else {
                this.props.updateMultipleState({
                  showDocNameEditAndContinueModal: false,
                  showEmptySignerPopup: true,
                });
              }
            } else {
              this.props.updateMultipleState({
                showDocNameEditAndContinueModal: false,
                showAnalysisModal: false,
                showSendConfirmationPopup: true,
              });
            }
          } else {
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              showEmptySignerPopup: true,
            });
          }
        } else if (this.props.buttonValue === "stripePayment") {
          const { stripePaymentDetails, buttonData } = this.props;
          if (
            buttonData.length &&
            ((stripePaymentDetails && !stripePaymentDetails.is_active) ||
              !stripePaymentDetails)
          ) {
            // if there is a disabled button in the doc
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              stripeButtonRemovePopup: true,
              buttonValue: this.props.buttonValue,
            });
          } else if (buttonData.length === 0) {
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              showEmptyStripePaymentPopup: true,
            });
          } else {
            this.props.updateMultipleState({
              showDocNameEditAndContinueModal: false,
              showAddRecipientsPopup: true,
            });
          }
        }

        Toastr.showToastr({
          type: "success",
          message: DOCUMENT_TOASTR_MESSAGE.DOCUMENT_RENAME,
          timeout: 3000,
        });
        amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_RENAMED, {
          initiatedFrom: "Document Popup",
          status: this.props.documentStatus && this.props.documentStatus.name,
          tag: this.props.documentTag && this.props.documentTag.name,
          DocumentID: this.props.docID,
          templateID: this.props.templateID,
        });
      })
      .catch(error => {
        console.error(
          `DocNameEditAndContinuePopup => _updateDocDetails => Error :  ${error}`,
        );
        this._toggleLoader("showButtunLoader", false);
        this.setState({ errMsg: "Something went wrong. Please try again!" });
      });
  };

  _onClose = () => {
    this.props.onClose("showDocNameEditAndContinueModal", false);
  };

  handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY) {
      this._onSubmit();
    }
  };

  render() {
    const { documentName, showButtunLoader, errMsg } = this.state;
    const errMsgSpace = errMsg ? (
      <div className="assetmodal-error-message">{errMsg}</div>
    ) : null;
    return (
      <Modal open onClose={this._onClose} center closeOnOverlayClick={false}>
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div
            className="quotationtopbar-modal-heading"
            data-test="quotationtopbar-modal-heading">
            Name the document before sharing
          </div>
          {errMsgSpace}
          <div className="quotationtopbar-form">
            <div className="quotationtopbar-form-field">
              <Label
                htmlFor="userEmail"
                data-test="quotationtopbar-input-label">
                Rename document
              </Label>
              <input
                className="form-control"
                data-test="quotationtopbar-docname-inputfield"
                type="text"
                name="documentName"
                value={documentName}
                onChange={this._onInputChange}
                onKeyDown={this.handleKeyDown}
                placeholder="Enter a document name."
                ref={name => {
                  this.documentNameInput = name;
                }}
              />
            </div>
          </div>
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-primary"
              data-test="quotationtopbar-docname-proceed-button"
              onClick={this._onSubmit}
              isLoading={showButtunLoader}>
              Next
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  updateDocDetails,
};

export default connect(
  null,
  mapDispatchToProps,
)(DocNameEditAndContinuePopup);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocNameEditAndContinuePopup.js